import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

/*
 * Docs
*/

// $ npm install swiper
import Swiper from 'swiper'; // import Swiper JS

// Home - Hero
const docsSwiperA = new Swiper('#docs #hero .swiper-container', {
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
});

// Home - Swiper
const docsSwiperB = new Swiper('#docs .swiper-fullscreen .swiper-container', {
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
});

// Home - Video
document.addEventListener('DOMContentLoaded', function () {
  var v = document.getElementById('docs-bgvideo');
  if(v){
    v.play();
  }
});
